import React, {useState} from 'react';
import {Checkbox, Form, Grid, Header, Segment, Table, TextArea} from 'semantic-ui-react';
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";
import {ToasterConfig} from "../../../../config/ToasterConfig";
import {CreateAppMessageRequest} from "../../../../models/requests/create-app-message-request";
import useAppMessagesService from "../../../../services/backoffice/hooks/useAppMessagesService";

const CreateAppMessagePage = () => {
    const [message, setMessage] = useState<Partial<CreateAppMessageRequest>>({});
    const navigate = useNavigate();
    const {createAppMessage} = useAppMessagesService();

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = event.target;
        setMessage((prevClient) => ({
            ...prevClient,
            [name]: value,
        }));
    };

    const handleCheckboxChange = (name: string, value: any) => {
        setMessage((prevColeta) => ({
            ...prevColeta,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        try {
            await createAppMessage({...message})
            // handle success
            navigate('/backoffice/app-messages/')
            toast.success('Mensagem criada com sucesso', ToasterConfig.success);
        } catch (error) {
        }
    };

    return (
        <div>
            <Grid.Column mobile={16} tablet={8} computer={6}>
                <Header as="h3" textAlign="center" color={'green'}>
                    Mensagens do Aplicativo / Adicionar
                </Header>
                <Segment>
                    <Form onSubmit={handleSubmit}>
                        <Form.Input
                            label="Assunto"
                            name="subject"
                            value={message.subject}
                            onChange={handleInputChange}
                            required
                        />
                        <Form.Field
                            control={TextArea}
                            label="Mensagem"
                            name="message"
                            value={message.message}
                            onChange={handleInputChange}
                            required
                        />
                        <Form.Input
                            label="Remetente"
                            name="sender"
                            value={message?.sender || ''}
                            onChange={handleInputChange}
                        />
                        <Form.Input
                            label="Data de expiração da mensagem"
                            name="dueDate"
                            type="datetime-local"
                            placeholder="Data de expiração da mensagem"
                            value={message?.dueDate || ''}
                            onChange={(e) => {
                                if (e.target.value.length !== 16) return
                                handleInputChange(e)
                            }}
                        />
                        <Form.Field>
                            <Checkbox
                                label="Pode marcar como lido?"
                                id="canMarkAsRead"
                                checked={message.canMarkAsRead}
                                onChange={(e, b) => handleCheckboxChange('canMarkAsRead', b.checked)}
                            />
                        </Form.Field>

                        <Table.Row>
                            <Table.HeaderCell>
                                <Form.Button content="Voltar"
                                             icon='arrow left'
                                             onClick={() => navigate('/backoffice/app-messages/')} grey/>
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                <Form.Button content="Adicionar"
                                             type={"submit"}
                                             icon='save'
                                             primary/>
                            </Table.HeaderCell>
                        </Table.Row>
                    </Form>
                </Segment>
            </Grid.Column>
        </div>
    );
};

export default CreateAppMessagePage;
